import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class BaseNPCView extends AbstractView {
    constructor(target) {
        super(target);
        this.scheduleAnimation();
    }

    destroy() {
        super.destroy();
    }

    reset() {
        this._target.gotoAndStop(0);
    }

    get skin() {
        return this._target;
    }

    scheduleAnimation() {
        const delay = Math.random() * (ANIMATION_DELAY[1] - ANIMATION_DELAY[0]) + ANIMATION_DELAY[0];
        this.callDelayed(this.animate.bind(this), delay);
    }

    animate() {
        const labels = this._target.labels;
        if (labels.length) {
            const label = Math.floor(Math.random() * labels.length);
            this._target.gotoAndPlay(label.position);
        }
        this.scheduleAnimation();
    }

};

const ANIMATION_DELAY = [3000, 6000];
